/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
const isMobile = window.innerWidth < 768;
export const CardContainerVariant: any = {
  whileHover: !isMobile
    ? {
        scale: 1.05,
        backgroundColor: '#dfdfdf',
        borderRadius: '10px',
        padding: '10px',
      }
    : {},
  transition: !isMobile
    ? {
        duration: 0.1,
      }
    : {},
};
